import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const InsuranceCardBlockConfigSchema = z.object({
  gsPath: z.string().min(1, 'Cloud storage path is required'),
});
export type InsuranceCardBlockConfig = z.infer<typeof InsuranceCardBlockConfigSchema>;

export const InsuranceCardBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.InsuranceCard),
  config: InsuranceCardBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.InsuranceCard),
});
export type InsuranceCardBlock = z.infer<typeof InsuranceCardBlockSchema>;
